package one.healthium.profile.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.arkivanov.decompose.extensions.compose.stack.Children
import one.healthium.decompose.platformPredictiveBackAnimation
import one.healthium.profile.ui.food_history.FoodHistoryScreen
import one.healthium.profile.ui.profile.ProfileScreen
import one.healthium.profile.ui.weight_history.WeightHistoryScreen
import one.healthium.settings.ui.health_kit.HealthKitSettingsScreen
import one.healthium.settings.ui.meal_plan.MealPlanSettingsScreen
import one.healthium.settings.ui.menu.SettingsMenuScreen
import one.healthium.settings.ui.settings.SettingsScreen

@Composable
fun ProfileMainContent(
    component: ProfileMainComponent
) {
    Children(
        modifier = Modifier.fillMaxSize(),
        stack = component.stack,
        animation = platformPredictiveBackAnimation(
            backHandler = component.backHandler,
            onBack = component::onBackClicked,
        )
    ) {
        when (val child = it.instance) {
            is ProfileMainComponent.Child.MealPlanSettings -> MealPlanSettingsScreen(child.component)
            is ProfileMainComponent.Child.ProfileChild -> ProfileScreen(child.component)
            is ProfileMainComponent.Child.SettingsChild -> SettingsScreen(child.component)
            is ProfileMainComponent.Child.SettingsMenu -> SettingsMenuScreen(child.component)
            is ProfileMainComponent.Child.WeightHistory -> WeightHistoryScreen(child.component)
            is ProfileMainComponent.Child.FoodHistory -> FoodHistoryScreen(child.component)
            is ProfileMainComponent.Child.HealthKitConnect -> HealthKitSettingsScreen(child.component)
        }
    }
}